import BaseModel from '@/models/list/base';

export default class OptionPair extends BaseModel {
  constructor(pair = {}, url) {
    super(pair, url);

    this.name = pair.name;
    this.image = pair?.images?.at(0) || pair.image;
  }

  get hasNotUploadImage() {
    return !this.image?.id;
  }

  get putFormat() {
    const {
      name,
      image,
      hasNotUploadImage,
    } = this;

    return {
      name: name || null,
      ...hasNotUploadImage ? { image } : [],
      delete_image: !!name,
    };
  }
}
